import { TransportStep } from '../enums/transport-step.enum';
import { PATHS } from '../bary-paths.model';
import { TunnelStep } from '../tunnel-step.model';

export const TUNNEL_STEPS = [
  new TunnelStep({
    title: 'ESTIMATION_TUNNEL.STEP.PICKUP',
    url: PATHS.ESTIMATE_PICKUP.path,
    hasPreviousStep: false,
    step: TransportStep.PICKUP,
    icon: 'truck-loading',
  }),
  new TunnelStep({
    title: 'ESTIMATION_TUNNEL.STEP.DELIVERY',
    url: PATHS.ESTIMATE_DELIVERY.path,
    step: TransportStep.DELIVERY,
    icon: 'shipping-fast',
  }),
  new TunnelStep({
    title: 'ESTIMATION_TUNNEL.STEP.ITEMS',
    url: PATHS.ESTIMATE_ITEMS.path,
    hasNextStep: false,
    step: TransportStep.ITEMS,
    icon: 'box',
  }),
];
